module.exports = __webpack_public_path__ + "static/media/Julia.4240a0ce.jpg";